export var createSetAudioNodeTailTime = function createSetAudioNodeTailTime(audioNodeTailTimeStore) {
  return function (audioNode, tailTime) {
    return audioNodeTailTimeStore.set(audioNode, tailTime);
  };
};